import { isNullOrUndefined } from '@r-and-a-shared-ui/utils';

export const replaceSpecialLabelValue = (label?: string) => {
  // this is added here to prevent autofill on iOS devices for country dropdown, as iOS autofill is based on label
  // and this will not affect the screen readers as it will read it as Country
  // Add here other special fields if needed in the future
  if (isNullOrUndefined(label)) {
    return label;
  }

  return label.replace('Country', 'Cou\u200Bntry');
};
